import { inject, injectable } from 'inversify';
import { ok, Result } from '@xlearn/common'
import msgpack from 'msgpack-lite';
import { FetchService, FetchServiceSymbol, FetchCommandError } from '@/app/fetch/service';
import { CancelToken } from '@/app/shared/utils/cancel-token';
import { joinUrl } from '@/app/shared/utils/base-path'

export const MsgPackCourseFileLoaderSymbol = Symbol.for('MsgPackCourseFileLoader')

type Error = FetchCommandError | {
  type: 'deserialization-error'
}

interface Source {
  uri: string;
  basePath: string;
}

@injectable()
export class MsgPackCourseFileLoader {

  constructor(
    @inject(FetchServiceSymbol)
    private fetchService: FetchService) {
  }

  public async load<T>(source: Source | string, cancelToken: CancelToken): Promise<Result<T, Error>> {

    let final = typeof source === 'string' ? source : joinUrl(source.basePath, source.uri)
    
    const fetchResult = await this.fetchService.query(final, cancelToken, 'arraybuffer')
    if (!fetchResult.success) {
      return fetchResult
    }

    const decoded = this.decodeFile(fetchResult.value)
    if (!decoded.success) {
      return decoded
    }

    const content = decoded.value
    // if (replaceBasePath && typeof content === 'object') {
    //   return walkObjectAndReplaceBasePaths(content, basePath)
    // }
    
    return ok(content as T)
  }

  private decodeFile(file: ArrayBuffer) {
    try {
      const result = msgpack.decode(new Uint8Array(file));
      return ok(result)
    } catch (err) {
      return err(err)
    }
  }
}
